import { Link } from '@tanstack/react-router';
import { cn } from '@/lib/cn';

// Sub-navigation shared across the parent Settings screens. The primary app
// nav links to a single "Settings" entry; this tab strip lets a parent move
// between the settings sub-pages (Notifications, Account) once they're there.

interface SettingsNavItem {
  to: string;
  label: string;
}

const ITEMS: SettingsNavItem[] = [
  { to: '/parent/settings/notifications', label: 'Notifications' },
  { to: '/parent/settings/account', label: 'Account' },
];

export function SettingsNav({ className }: { className?: string }) {
  return (
    <nav aria-label="Settings sections" className={cn('flex flex-wrap gap-1', className)}>
      {ITEMS.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          className="rounded-[var(--radius-md)] px-3 py-1.5 text-[var(--color-ink-muted)] text-[var(--text-sm)] transition-colors duration-[var(--duration-fast)] hover:bg-[var(--color-surface-sunken)] hover:text-[var(--color-ink)] aria-[current=page]:bg-[var(--color-accent-muted)] aria-[current=page]:font-medium aria-[current=page]:text-[var(--color-ink)]"
        >
          {item.label}
        </Link>
      ))}
    </nav>
  );
}
